var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVodonagrevatelIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 250 250",
    style: {
      enableBackground: "new 0 0 250 250"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#DE1427;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M125,229.48c-15.88,0-31.85-0.64-47.77-1.78c0,4.63,0,7.49,0,14.3c31.72,9.27,63.82,9.27,95.54,0 c0-6.81,0-9.68,0-14.3C156.85,228.83,140.88,229.48,125,229.48z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M208.42,216.51c0,2.51-1.87,4.62-4.37,4.92c-52.51,6.28-105.58,6.28-158.09,0 c-2.49-0.3-4.37-2.41-4.37-4.92c0-3.75,0-5.86,0-11.2c55.61,0,111.22,0,166.83,0C208.42,210.65,208.42,212.76,208.42,216.51z  M62.97,220.98c6.65,0.61,13.3,1.12,19.96,1.54v-14.93H62.97V220.98z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M208.42,23.54c-55.61,0-111.22,0-166.83,0c0-5.35,0-7.45,0-11.2c0-2.51,1.87-4.62,4.37-4.92 c52.51-6.28,105.58-6.28,158.09,0c2.49,0.3,4.37,2.41,4.37,4.92C208.42,16.08,208.42,18.19,208.42,23.54z M82.94,6.33 c-6.66,0.41-13.31,0.93-19.96,1.54V21h19.96V6.33z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M208.42,200.69H41.58V28.15h166.83V200.69z M62.97,31.26v166.32h19.96V31.26H62.97z M125,88.71 c-14.2,0-25.71,11.51-25.71,25.71s11.51,25.71,25.71,25.71c14.2,0,25.71-11.51,25.71-25.71S139.2,88.71,125,88.71z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M103.37,106.49l3.57,1.51c2.82-7.1,9.56-12.1,17.44-12.1v-3.99C114.88,91.92,106.76,97.95,103.37,106.49z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M143.38,108l3.57-1.51c-3.39-8.55-11.52-14.57-21.01-14.57v3.99C133.82,95.91,140.56,100.91,143.38,108z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "118.69,97.51 117.94,97.83 117.19,98.14 126.2,121.77 127.73,121.13 129.26,120.49  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M127.86,114.63c0,1.58-1.28,2.86-2.86,2.86c-1.58,0-2.86-1.28-2.86-2.86s1.28-2.86,2.86-2.86 C126.58,111.78,127.86,113.06,127.86,114.63z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVodonagrevatelIcon);
export default __webpack_public_path__ + "static/media/vodonagrevatel_icon.f402741f59d95598e306f8f6a1afdb63.svg";
export { ForwardRef as ReactComponent };